import React, { useState, useEffect } from "react";
import TextInputNoLabel from "../../../ShareElements/TextInput/TextInputNolabel";
import Switch from "../../../ShareElements/TextInput/Switch";
import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import { Config } from "../../../../../../Config";
import DesktopOnlyOverlay from "../../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import TextAreaNoLabel from "../../../ShareElements/TextInput/TextAreaNolabel";

const BasicSettings = (props) => {
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [DialogueIsOpen, setDialogueIsOpen] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [ACLtoEdit, setACLtoEdit] = useState({});

  useEffect(() => {
    // saved as a variable (base64 string) and set here as the profile we want to edit (type of object)
    let ACL = JSON.parse(atob(window.localStorage.getItem("SelectedACL")));
    setACLtoEdit(ACL);
    window.localStorage.setItem("LastIdClicked", "");
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const handleInputChange = (InputId) => {
    enableSave();
  };
  const handleSwitchChange = (Id) => {
    enableSave();
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setUnsavedChanges(true);
    } else {
      window.location.assign("/home/acls");
    }
  };
  const discardAndLeave = () => {
    window.location.assign("/home/acls");
  };
  const validateEntries = () => {
    let Name = document.getElementById("name").value;
    if (Name.length <= 0) {
      showEmptyNameError();
      window.localStorage.setItem("HasUnsaveChanges", 1);
    } else {
      submitEdit();
    }
  };
  const showEmptyNameError = () => {
    setValidationMessage("Please, fill the field.");
    document.getElementById("name-label-holder").classList.add("wrong");
    setTimeout(() => {
      document.getElementById("name-label-holder").classList.remove("wrong");
    }, 3000);
  };
  const showNameFieldError = (ErrorMessage) => {
    setValidationMessage(ErrorMessage);
    document.getElementById("name-label-holder").classList.add("wrong");
    setTimeout(() => {
      document.getElementById("name-label-holder").classList.remove("wrong");
    }, 3000);
  };
  const closeAlert = () => {
    setUnsavedChanges(false);
  };
  const saveAndLeave = () => {
    setUnsavedChanges(false);
    if (document.getElementById("name-label-holder").classList.length < 2) {
      if (window.localStorage.getItem("LastIdClicked").length > 0) {
        validateEntries();
      } else {
        validateEntries();
        setTimeout(() => {
          if (
            document.getElementById("name-label-holder").classList.length < 2
          ) {
            window.location.assign("/home/acls");
          } else {
            return null;
          }
        }, 1500);
      }
    }
  };
  const submitEdit = () => {
    let ProfileInfo = {
      description: document.getElementById("description").value,
      name: document.getElementById("name").value,
      id: ACLtoEdit.id,
    };
    if (document.getElementById("status-switch-holder").classList.length > 1) {
      ProfileInfo.enabled = false;
    } else {
      ProfileInfo.enabled = true;
    }
    if (
      document.getElementById("all-records-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeAllRecords = false;
    } else {
      ProfileInfo.includeAllRecords = true;
    }
    if (
      document.getElementById("unassigned-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeUnAssigned = false;
    } else {
      ProfileInfo.includeUnAssigned = true;
    }
    if (
      document.getElementById("own-records-switch-holder").classList.length > 1
    ) {
      ProfileInfo.includeRequester = false;
    } else {
      ProfileInfo.includeRequester = true;
    }
    let Req = {
      method: "PUT",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/acl",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: ProfileInfo,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setACLtoEdit(Res.data);
        let ACLObject = JSON.stringify(Res.data);
        let ACLBase64 = Buffer.from(ACLObject).toString("base64");
        window.localStorage.setItem("SelectedACL", ACLBase64);
        setACLtoEdit(Res.data);
        disableSaveBtn();
      })
      .catch((Err) => {
        console.log(Err);
        if (Err.response.data.key === "duplicate_error") {
          showNameFieldError("An ACL with this name already exists.");
        }
      });
  };
  return (
    <div className="acl-edit-form">
      <DesktopOnlyOverlay LangData={props.LangData} />
      {UnsavedChanges ? (
        <UnsavedChangesAlert
          close={() => closeAlert()}
          saveAndLeave={() => saveAndLeave()}
          discardAndLeave={() => discardAndLeave()}
          LangData={props.LangData}
        />
      ) : null}
      <div className="form">
        <section className="form-header">
          <button className="return" onClick={() => cancelOperation()}>
            <i className="feather-arrow-left"></i>
          </button>
          {ACLtoEdit.name ? <h1>{ACLtoEdit.name}</h1> : <h1>Edit ACL</h1>}
          <div className="action-btn-group">
            <button onClick={() => cancelOperation()} className="cancel">
              {translateText("cancel")}
            </button>
            <button
              onClick={() => validateEntries()}
              id="save-btn"
              className="save disabled"
            >
              {translateText("save")}
            </button>
          </div>
        </section>
        <section className="form-body">
          <div className="form-head">
            <h1>{translateText("general_info")}</h1>
          </div>
        </section>
        <div className="row">
          <p className="name">
            {translateText("name")} <p className="required">*</p>
          </p>
          <TextInputNoLabel
            ChangeEvent={() => handleInputChange("name")}
            Id="name"
            PlaceHolder={translateText("acl_name")}
            InitialValue={ACLtoEdit.name}
            ValidationMessage={validationMessage}
          />
        </div>
        <div className="row">
          <p className="name">{translateText("status")}</p>
          {ACLtoEdit.enabled === undefined ? null : (
            <Switch
              ChangeEvent={() => handleSwitchChange("status")}
              Id="status"
              PlaceHolder="Profile Name"
              IsActive={ACLtoEdit.enabled}
            />
          )}
        </div>
        <div className="row">
          <p className="name float-top">{translateText("description")}</p>
          <TextAreaNoLabel
            ChangeEvent={() => handleInputChange("name")}
            Id="description"
            PlaceHolder={translateText("optional")}
            ValidationMessage="Please, fill the field."
            InitialValue={ACLtoEdit.description}
          />
        </div>
        <div className="section-separator"></div>
        <section className="form-body">
          <div className="form-head">
            <h1>{translateText("access_settings")}</h1>
          </div>
        </section>
        <div className="row">
          <section className="field-description">
            <div className="with-info">
              <p className="name field-name">
                {" "}
                {translateText("include_all_records")}
              </p>
              <button onClick={() => setDialogueIsOpen(true)}>
                <i className="feather-alert-circle"></i>
                <section className="dialogue-body">
                  <p>{translateText("add_acl_info_button_text")}</p>
                </section>
              </button>
              {ACLtoEdit.includeAllRecords === undefined ? null : (
                <Switch
                  ChangeEvent={() => handleSwitchChange("all-records")}
                  Id="all-records"
                  IsActive={ACLtoEdit.includeAllRecords}
                />
              )}
            </div>
            <p className="info">{translateText("all_records_info")}.</p>
          </section>
        </div>
        <div className="row">
          <section className="field-description">
            <p className="name field-name">
              {translateText("include_unassigned")}
            </p>
            <p className="info long-info">
              {translateText("unassigned_info")}.
            </p>
          </section>
          {ACLtoEdit.includeUnAssigned === undefined ? null : (
            <Switch
              ChangeEvent={() => handleSwitchChange("unassigned")}
              Id="unassigned"
              IsActive={ACLtoEdit.includeUnAssigned}
            />
          )}
        </div>
        <div className="row">
          <section className="field-description">
            <p className="name field-name">
              {translateText("include_own_records")}
            </p>
            <p className="info">{translateText("own_records_info")}.</p>
          </section>
          {ACLtoEdit.includeRequester === undefined ? null : (
            <Switch
              ChangeEvent={() => handleSwitchChange("own-records")}
              Id="own-records"
              IsActive={ACLtoEdit.includeRequester}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicSettings;
